// extracted by mini-css-extract-plugin
export default {"form":"styles_form__busZb","error":"styles_error__EDpT3","input":"styles_input__tRj-l"};